import { SxProps, Theme } from '@mui/material/styles';
import { AI_GRADIENT_CSS } from 'common/constants/ai';

export const acceptAllConfirmButtonSx: SxProps<Theme> = {
  background: AI_GRADIENT_CSS,
  color: 'white',
  fontWeight: 600,
  textTransform: 'none',
  '&:hover': { filter: 'brightness(0.9)', background: AI_GRADIENT_CSS },
  '&.Mui-disabled': { background: AI_GRADIENT_CSS, opacity: 0.6, color: 'white' },
};
